import { ProjectRunStatusTypeEnum } from "@app/projects/enumerators";
import { ProjectRunStatusObject } from "@app/projects/projectRunStatusObject";
import ServiceBase from "@app/shared/serviceBase";

export default class ProjectRunConfigurationService extends ServiceBase {

  public async getProjectRunConfigurationStatus(projectRunConfigurationId: number, statusType = ProjectRunStatusTypeEnum.ProjectRunStatus): Promise<ProjectRunStatusObject> {
      return await this.makeGet(`projectRunConfigurations/${projectRunConfigurationId}/status?statusType=${statusType}`)
  }
}